var map = {
	"./attendanceapp (2).jpg": 22245,
	"./attendanceapp.jpg": 69378,
	"./billsample.png": 53703,
	"./certificates.png": 46610,
	"./mailing.png": 2887,
	"./sample.jpg": 79396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86472;